"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGlobalTreeEditWarning = void 0;
const react_1 = require("react");
const graphql_1 = require("../../../__generated__/graphql");
const react_redux_1 = require("react-redux");
const global_tree_edit_warning_utils_1 = require("./global-tree-edit-warning.utils");
const attributes_1 = require("../../client/attributes");
const client_constants_1 = require("../../client/client.constants");
const product_tree_1 = require("../../client/product-tree");
const product_tree_node_1 = require("../../client/product-tree-node");
const product_tree_nodes_1 = require("../../client/product-tree-nodes");
const hooks_1 = require("../../hooks");
const task_view_1 = require("../../store/catalogs/task-view");
const store_1 = require("../../strategy-matrix/store");
const hooks_2 = require("../../../hooks");
const localization_1 = require("../../../localization");
const store_2 = require("../../../store");
const useGlobalTreeEditWarning = (selectedStrategyNodeId) => {
    var _a;
    const dispatch = (0, react_redux_1.useDispatch)();
    const { addError } = (0, hooks_2.useNotification)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const productTreeId = (0, store_2.useProductTreeId)();
    const catalogName = (0, hooks_1.useSelectedCatalogName)();
    const selectedCatalogId = (0, store_2.useSelectedCatalogId)();
    const selectedStrategyNodeResponse = (0, product_tree_node_1.useProductTreeNode)({ id: selectedStrategyNodeId !== null && selectedStrategyNodeId !== void 0 ? selectedStrategyNodeId : '' });
    const { title: selectedStrategyNodeTitle } = (_a = selectedStrategyNodeResponse === null || selectedStrategyNodeResponse === void 0 ? void 0 : selectedStrategyNodeResponse.data) !== null && _a !== void 0 ? _a : {};
    const { cloneAndAttachProductTreeToCatalog } = (0, product_tree_1.useCloneAndAttachProductTree)();
    const { getTreeNodePaths } = (0, product_tree_nodes_1.useTreeNodePaths)();
    const restoreSelectedProductTreeNodeByTitle = (0, react_1.useCallback)((productTreeId, rootNodeId, title) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (!title) {
            return null;
        }
        if (title === attributes_1.ONTOLOGY_NODE_TITLE) {
            return rootNodeId;
        }
        try {
            const { data: nodePaths } = yield getTreeNodePaths({
                variables: {
                    productTreeId,
                    filter: { title: { equals: title } },
                    first: client_constants_1.PAGE_SIZE_LARGE,
                    firstAncestors: client_constants_1.PAGE_SIZE_LARGE,
                    sort: [{ distance: graphql_1.SortOrder.Asc }],
                },
            });
            const targetNodePath = (_a = nodePaths === null || nodePaths === void 0 ? void 0 : nodePaths[0]) !== null && _a !== void 0 ? _a : '';
            const newExpandedPaths = (0, product_tree_nodes_1.getExpandedNodesListByPath)(targetNodePath);
            dispatch((0, store_2.enrichAISetSelectedTreeNodePath)(targetNodePath));
            dispatch((0, store_2.enrichAISetExpandedNodes)(newExpandedPaths));
            return targetNodePath;
        }
        catch (error) {
            console.error('Error restoring product tree node:', error);
            dispatch((0, store_2.enrichAISetSelectedTreeNodePath)(rootNodeId));
            dispatch((0, store_2.enrichAISetExpandedNodes)([]));
            return null;
        }
    }), [dispatch, getTreeNodePaths]);
    const onGlobalTreeReplacement = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        try {
            const { data } = yield cloneAndAttachProductTreeToCatalog({
                variables: {
                    productTreeId,
                    title: (0, global_tree_edit_warning_utils_1.getCopyProductTreeTitle)(catalogName),
                    catalogId: selectedCatalogId,
                },
            });
            const { id, title, myPermissions, root, tags, } = (_a = data.editProductTree.productTree) !== null && _a !== void 0 ? _a : {};
            const { id: rootNodeId } = root !== null && root !== void 0 ? root : {};
            const targetNodePath = yield restoreSelectedProductTreeNodeByTitle(id, rootNodeId, selectedStrategyNodeTitle);
            const targetNodeIds = (0, product_tree_nodes_1.getTreeNodeIdsFromPath)(targetNodePath !== null && targetNodePath !== void 0 ? targetNodePath : '');
            const targetNodeId = targetNodeIds.pop();
            const l1NodeId = targetNodeIds[product_tree_node_1.L1_NODE_ANCESTOR_NUMBER];
            dispatch((0, store_2.enrichAISetProductTree)({
                id,
                title,
                permissions: myPermissions,
                tags: (_c = (_b = tags.edges) === null || _b === void 0 ? void 0 : _b.map((item) => item.node)) !== null && _c !== void 0 ? _c : [],
                rootNodeId,
            }));
            dispatch((0, store_2.enrichAIRemoveChanges)(selectedCatalogId));
            dispatch((0, task_view_1.setTaskViewSelectedTreeNodePath)(selectedCatalogId, rootNodeId));
            dispatch((0, store_1.setTreeNodeFilteringStateForStrategyMatrix)(selectedCatalogId, {
                extendedFilter: targetNodeId && targetNodeId !== rootNodeId ? [{ id: l1NodeId, children: [targetNodeId] }] : [],
                exclusiveFilter: [],
            }));
            return {
                rootNodeId,
                targetNodeId,
            };
        }
        catch (error) {
            addError(t({ key: 'GLOBAL_TREE_LOCAL_COPY_CREATION_ERROR' }));
            throw new Error(error.message);
        }
    }), [
        addError,
        catalogName,
        cloneAndAttachProductTreeToCatalog,
        dispatch,
        productTreeId,
        restoreSelectedProductTreeNodeByTitle,
        selectedCatalogId,
        selectedStrategyNodeTitle,
        t,
    ]);
    return { onGlobalTreeReplacement };
};
exports.useGlobalTreeEditWarning = useGlobalTreeEditWarning;
